import script from "./showStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./showStatus.vue?vue&type=script&setup=true&lang=js"

import "./showStatus.vue?vue&type=style&index=0&id=7def2ac8&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7def2ac8"]])

export default __exports__